import { ChartEvent, ChartType, LegendElement, LegendItem } from 'chart.js';
import React from 'react';
import { isLegendDatasetHidden, toggleIsolatedLegendItem } from './chartLegendIsolation';

export function useChartLegendIsolation(resetToken: unknown) {
    const [isolatedLabel, setIsolatedLabel] = React.useState<string | null>(null);

    React.useEffect(() => {
        setIsolatedLabel(null);
    }, [resetToken]);

    const handleLegendClick = React.useCallback((
        _event: ChartEvent,
        legendItem: LegendItem,
        _legend: LegendElement<ChartType>,
    ) => {
        const clickedLabel = String(legendItem.text ?? '');
        setIsolatedLabel(currentIsolatedLabel => toggleIsolatedLegendItem(currentIsolatedLabel, clickedLabel));
    }, []);

    const isDatasetHidden = React.useCallback((datasetLabel: string) => {
        return isLegendDatasetHidden(isolatedLabel, datasetLabel);
    }, [isolatedLabel]);

    return {
        isolatedLabel,
        handleLegendClick,
        isDatasetHidden,
    };
}
